import type { QuoteConversionSummary } from './types';

/**
 * v2.33 quote→invoice conversion rollup (pacebi-observed; Pacesetter itself
 * keeps no conversion trail). 503 means the tracker is disabled server-side;
 * both that and 403 resolve to null so the card simply doesn't render.
 */
export async function fetchQuoteConversion(days = 30): Promise<QuoteConversionSummary | null> {
  try {
    const res = await fetch(`/api/quote-conversion?days=${days}`, { credentials: 'same-origin' });
    if (!res.ok) return null;
    return (await res.json()) as QuoteConversionSummary;
  } catch {
    return null;
  }
}
